/* Dr.Primal — the buy box's UGC video modal.
 *
 * The tiles on the page are stills; this file is the only thing that ever loads a video
 * byte, and only after a click. The player is one <video> in a native <dialog>, so focus
 * trapping, Escape and the backdrop are the platform's. The `src` is written on open and
 * removed again on close — with four slots, leaving it set kept the last video buffered
 * for the rest of the visit.
 *
 * Autoplay after the click is user-initiated playback and allowed with sound; a browser
 * that blocks it anyway leaves the player's own controls showing, which is a working
 * state, so the play() rejection is deliberately ignored.
 */
(function () {
  'use strict';

  if (window.dpUgcModalLoaded) return;
  window.dpUgcModalLoaded = true;

  function init() {
    var modal = document.querySelector('[data-dp-ugc-modal]');
    if (!modal || typeof modal.showModal !== 'function') return;

    var player = modal.querySelector('[data-dp-ugc-player]');
    if (!player) return;

    function open(src) {
      player.src = src;
      modal.showModal();
      var started = player.play();
      if (started && started.catch) started.catch(function () {});
    }

    function shutDown() {
      player.pause();
      player.removeAttribute('src');
      player.load();
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      var trigger = event.target.closest('[data-dp-ugc-open]');
      if (trigger) {
        var src = trigger.getAttribute('data-dp-ugc-src');
        if (src) open(src);
        return;
      }

      if (event.target.closest('[data-dp-ugc-close]')) {
        modal.close();
        return;
      }

      // A click on the dialog element itself is a click on the backdrop: the player and
      // the close button fill everything inside it.
      if (event.target === modal) {
        modal.close();
      }
    });

    // Fires for every way out — the close button, Escape, form method dialog — so the
    // teardown cannot be skipped by the path this file did not think of.
    modal.addEventListener('close', shutDown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
